export function isEdit(state) {
    return state.reservationProduct && state.reservationProduct.id;
}



// WEBPACK FOOTER //
// ./src/modules/reservationProduct/getters.js